<template>
  <div class="stamp">
    <div class="h_title">回收站管理</div>
    <div class="h_body">
      <!-- <div class="hb_head">
        <sw-button
          icon="su-icon-plus"
          type="primary"
          @click="handleAddStamp"
        >添加签章</sw-button>
        <sw-search
          :placeholder="'请输入签章名称'"
          @search="handleStampSearch"
        />
      </div> -->
      <div class="hb_main">
        <sw-table
          v-loading="stampTable.loading"
          :table-name="'stamp-table'"
          :table-data="stampTable.data"
          :table-title="stampTable.title"
          :show-selection="false"
          :total-count="stampTable.count"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="stampTable.pageSize"
          :empty-text="'暂无数据'"
          pagination
          @change-page="changePage"
          @size-change="changeSize"
        />
      </div>
      <sw-dialog
        :close-on-click-modal="false"
        :visible.sync="stampDialog.visible"
        :title="stampDialog.title"
      >
        <span slot="footer">
          <sw-button
            size="small"
            @click="stampDialog.visible=!stampDialog.visible"
          >取 消</sw-button>
          <sw-button
            :loading="stampDialog.loading"
            size="small"
            type="primary"
            @click="handleStampFormSubmit"
          >{{ stampDialog.confirmButtonText }}</sw-button>
        </span>
        <el-form
          ref="stampForm"
          :model="stampForm"
          :rules="stampForm.rules"
          :sw-validator="true"
          class="stamp-form"
          label-width="100px"
        >
          <el-form-item
            label="名称"
            prop="name"
          >
            <el-input
              v-model="stampForm.name"
              maxlength="50"
            />
          </el-form-item>
          <el-form-item
            label="备注"
            prop="description"
            style="margin-top: 50px"
          >
            <el-input
              v-model="stampForm.description"
              type="textarea"
              maxlength="100"
              show-word-limit
            />
          </el-form-item>
          <el-form-item
            label="签章"
            style="margin-top: 50px"
            prop="stamp"
          >
            <el-upload
              :disabled="stampDialog.confirmButtonText==='更新'"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleStampUploaderChange"
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
            >
              <img
                v-if="stampForm.stamp"
                :src="stampForm.stamp"
                style="width:200px;height:200px"
                class="avatar"
              >
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              />
            </el-upload>
          </el-form-item>
        </el-form>
      </sw-dialog>
      <sw-dialog
        :close-on-click-modal="false"
        :visible.sync="authTableDialog.visible"
        :title="authTableDialog.title"
      >
        <div class="authTableDialog_head">
          <el-radio-group
            v-model="authTable.type"
            @change="changeAuthType"
          >
            <el-radio label="group">用户组</el-radio>
            <el-radio label="org">组织机构</el-radio>
            <el-radio label="go">用户组&amp;机构</el-radio>
          </el-radio-group>
          <sw-button
            icon="su-icon-plus"
            type="primary"
            @click="handleAddAuth"
          >添加授权</sw-button>
        </div>
        <sw-table
          v-loading="authTable.loading"
          :table-name="'auth-table'"
          :table-data="authTable.data"
          :table-title="authTable.title"
          :key="'authTable'+authTable.key"
          :show-selection="false"
          :total-count="authTable.count"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="authTable.pageSize"
          :empty-text="'没有授权数据'"
          :table-operation="authTable.operation"
          style="margin-top:20px"
          pagination
          @operation-handle="handleAuthOperation"
          @change-page="changeAuthPage"
          @size-change="changeAuthSize"
        />
      </sw-dialog>
      <sw-dialog
        :close-on-click-modal="false"
        :visible.sync="authFormDialog.visible"
        :title="authFormDialog.title"
      >
        <span slot="footer">
          <sw-button
            size="small"
            @click="authFormDialog.visible=!authFormDialog.visible"
          >取 消</sw-button>
          <sw-button
            :loading="authFormDialog.loading"
            size="small"
            type="primary"
            @click="handleAuthFormSubmit"
          >{{ authFormDialog.confirmButtonText }}</sw-button>
        </span>
        <el-form
          ref="authForm"
          :model="authForm"
          :rules="authForm.rules"
          :sw-validator="true"
          class="auth-form"
          label-position="top"
        >
          <el-form-item
            v-if="authTable.type==='group'||authTable.type==='go'"
            label="用户组查询"
            prop="groupId"
          >
            <el-select
              v-model="authForm.groupId"
              :remote-method="getRoleList"
              :loading="authForm.groupLoading"
              filterable
              remote
              placeholder="请搜索用户组"
            >
              <el-option
                v-for="item in authForm.groupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="authTable.type==='org'||authTable.type==='go'"
            label="组织机构查询"
            prop="orgId"
          >
            <el-cascader
              v-model="authForm.orgId"
              :options="authForm.orgOptions"
              :props="authForm.orgProps"
              size="medium"
              placeholder="请选中组织机构"
              filterable
            />
          </el-form-item>
          <el-form-item
            label="备注"
            prop="description"
          >
            <el-input
              v-model="authForm.description"
              type="textarea"
              maxlength="100"
              show-word-limit
            />
          </el-form-item>
        </el-form>
      </sw-dialog>
    </div>
  </div>
</template>

<script>
import service from '@/utils/service'
import { parseTime } from '@/utils/index.js'
export default {
  name: 'Recycle',
  directives: {
    'loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          '.el-select-dropdown .el-select-dropdown__wrap'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight + 20
          if (condition) {
            binding.value()
          }
        })
      }
    }
  },
  data () {
    return {
      stampForm: {
        name: '',
        description: '',
        stamp: '',
        rules: {
          // 应用弹出表单验证规则
          name: [
            { required: true, message: '请输入名称', trigger: 'change' },
            {
              min: 1,
              max: 50,
              message: '请填写1～50个字符',
              trigger: 'blur'
            }
          ],
          desc: [{ required: false, message: '请填写备注', trigger: 'change' }],
          stamp: [{ required: true, message: '请选择签章', trigger: 'change' }]
        }
      },
      stampTable: {
        keyword: '',
        pageNum: 1,
        pageSize: 10,
        loading: false,
        count: 0,
        data: [],
        title: [{ prop: 'ff_name', label: '名称' }, { prop: 'create_by', label: '创建人' }, { prop: 'create_time', label: '创建时间' }, { prop: 'ff_describe', label: '描述' }],
        operation: [
          { name: '详情', icon: 'su-icon-details', operation: 'detail' },
          { name: '授权', icon: 'su-icon-people', operation: 'auth' },
          { name: '删除', icon: 'su-icon-delete', operation: 'delete' }
        ]
      },
      stampDialog: {
        visible: false,
        title: '签章',
        confirmButtonText: '确定',
        loading: false
      },
      authTable: {
        keyword: '',
        pageNum: 1,
        pageSize: 10,
        loading: false,
        count: 0,
        data: [],
        title: [{ prop: 'createBy', label: '创建人' }, { prop: 'createTime', label: '创建时间' }, { prop: 'description', label: '备注' }],
        originTitle: [{ prop: 'createBy', label: '创建人' }, { prop: 'createTime', label: '创建时间' }, { prop: 'description', label: '备注' }],
        operation: [
          { name: '删除', icon: 'su-icon-delete', operation: 'delete' }
        ],
        type: 'group',
        stampId: '',
        key: 0
      },
      authForm: {
        groupId: '',
        orgId: '',
        description: '',
        groupLoading: false,
        orgLoading: false,
        groupOptions: [],
        orgOptions: [],
        orgProps: { label: 'ins_name', value: 'id', checkStrictly: true },
        type: 'group',
        stampId: '',
        rules: {
          // 应用弹出表单验证规则
          groupId: [
            { required: true, message: '请选择用户组', trigger: 'change' }
          ],
          orgId: [
            { required: true, message: '请选择组织机构', trigger: 'change' }
          ]
        }
      },
      authTableDialog: {
        visible: false,
        title: '签章授权',
        confirmButtonText: '确定',
        loading: false
      },
      authFormDialog: {
        visible: false,
        title: 'group',
        confirmButtonText: '确定',
        loading: false
      },
      authType: {
        group: '用户组',
        org: '组织机构',
        go: '用户组加机构'
      }
    }
  },
  created () {
    this.getStampList()
    this.getOrgList()
  },
  mounted () {
  },
  methods: {
    getStampList () {
      const params = {
        page: this.stampTable.pageNum,
        limit: this.stampTable.pageSize
      }
      this.stampTable.loading = true
      service
        .get('/v1/recycle/queryAllRecycleData', { params })
        .then(res => {
          this.stampTable.data = res.data.map(v => {
            v.create_time = parseTime(v.create_time)
            return v
          })
          this.stampTable.count = res.count
        }).finally(() => {
          this.stampTable.loading = false
        })
    },
    handleStampSearch (val) {
      this.stampTable.keyword = val || ''
      this.getStampList()
    },
    handleAddStamp () {
      this.stampDialog.confirmButtonText = '确定'
      this.stampDialog.visible = true
      this.$nextTick(() => {
        this.$refs.stampForm.resetFields()
      })
    },
    handleStampUploaderChange (file) {
      const is50kb = file.size <= 100 * 1024 // 限制小于50kb
      if (!is50kb) {
        this.$swMessage({
          message: `签章图片大小限制为100kb,该图片尺寸为${(file.size / 1024).toFixed(
            2
          )}kb`,
          type: 'error'
        })
        return
      }
      const _this = this
      const reader = new FileReader()
      reader.readAsDataURL(file.raw)
      reader.onload = function (event) {
        const imgBase64 = this.result
        _this.stampForm.stamp = imgBase64
        _this.$refs.stampForm.validateField('stamp')
      }
    },
    handleStampFormSubmit () {
      this.$refs.stampForm.validate((valid) => {
        if (valid) {
          this.stampDialog.confirmButtonText === '确定' ? this.handleStampPost() : this.handleStampUpdate()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleStampPost () {
      this.stampDialog.loading = true
      service({
        method: 'post',
        url: '/v1/stamp/add',
        data: {
          description: this.stampForm.description,
          name: this.stampForm.name,
          stamp: this.stampForm.stamp
        },
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
        transformRequest: [
          function (data) {
            return JSON.stringify(data)
          }
        ]
      })
        .then(res => {
          if (res.flag) {
            this.$swMessage({
              message: res.msg,
              type: 'success'
            })
            this.getStampList()
            this.stampDialog.visible = false
          }
        })
        .catch(error => {
          this.$swMessage.error(error)
        })
        .finally(() => {
          this.stampDialog.loading = false
        })
    },
    handleStampUpdate () {
      this.stampDialog.loading = true
      service({
        method: 'post',
        url: '/v1/stamp/update',
        data: {
          description: this.stampForm.description,
          name: this.stampForm.name,
          id: this.stampForm.id,
          stamp: this.stampForm.stamp
        },
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
        transformRequest: [
          function (data) {
            return JSON.stringify(data)
          }
        ]
      })
        .then(res => {
          if (res.flag) {
            this.$swMessage({
              message: res.msg,
              type: 'success'
            })
            this.getStampList()
            this.stampDialog.visible = false
          }
        })
        .catch(error => {
          this.$swMessage.error(error)
        })
        .finally(() => {
          this.stampDialog.loading = false
        })
    },
    handleOperation (id, operation) {
      switch (operation) {
        case 'auth':

          this.handleStampAuth(id)
          break
        case 'delete':
          this.handleStampDelete(id)
          break
        default:
          this.handleStampDetail(id)
      }
    },
    handleStampDelete (id) {
      this.$swConfirm('确认删除？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            id: id
          }
          return service.get('/v1/stamp/delete', { params: param })
        })
        .then(res => {
          this.$swMessage.success(res.msg)
          this.stampTable.pageNum = 1
          this.getStampList()
        })
        .catch(res => {
          this.$swMessage.error(res.msg)
        })
    },
    handleStampDetail (id) {
      const row = this.getRow(this.stampTable.data, 'id', id)
      Object.assign(this.stampForm, row)
      this.stampDialog.confirmButtonText = '更新'
      this.stampDialog.visible = true
    },
    handleStampAuth (id) {
      this.authTable.stampId = id
      this.authForm.stampId = this.authTable.stampId
      this.authForm.type = this.authTable.type
      this.getAuthList()

      this.authTableDialog.visible = true
    },
    changeAuthType () {
      this.authTable.pageNum = 1
      this.getAuthList()
    },
    handleAuthTableTitle (type) {
      let arr = []
      switch (type) {
        case 'group':
          arr = [{ label: '用户组名称', prop: 'groupName' }]
          this.authTable.title = arr.concat(this.authTable.originTitle)
          break
        case 'org':
          arr = [{ label: '组织机构名称', prop: 'organizationName' }]
          this.authTable.title = arr.concat(this.authTable.originTitle)
          break
        case 'go':
          arr = [{ label: '用户组名称', prop: 'groupName' }, { label: '组织机构名称', prop: 'organizationName' }]
          this.authTable.title = arr.concat(this.authTable.originTitle)
          break
      }
      console.log(type, this.authTable.title)
    },
    getAuthList () {
      this.handleAuthTableTitle(this.authTable.type)
      if (this.authTable.pageNum === 1) {
        this.authTable.key++
      }
      const params = {
        pageNum: this.authTable.pageNum,
        pageSize: this.authTable.pageSize,
        stampId: this.authTable.stampId,
        type: this.authTable.type
      }
      this.authTable.loading = true
      service
        .get('/v1/stamp/authList', { params })
        .then(res => {
          this.authTable.data = res.data.map(v => {
            v.createTime = parseTime(v.createTime)
            return v
          })
          this.authTable.count = res.count
        }).finally(() => {
          this.authTable.loading = false
        })
    },
    handleAddAuth () {
      this.authFormDialog.visible = true
      this.authFormDialog.title = this.authType[this.authTable.type]
      this.authForm.groupId = ''
      this.authForm.orgId = ''
      this.authForm.description = ''
    },
    getRoleList (query) {
      const params = {
        roleName: query,
        page: 1,
        limit: 20
      }
      if (this.authForm.groupLoading) {
        return
      }
      this.authForm.groupLoading = true
      service.get('/v1/role/showRoleList', { params })
        .then(res => {
          console.log(res)
          this.authForm.groupOptions = res.data.map(v => {
            return { label: v.roleName, value: v.id }
          })
        }).finally(() => {
          this.authForm.groupLoading = false
        })
    },
    getOrgList () {
      if (this.authForm.orgLoading) {
        return
      }
      this.authForm.orgLoading = true
      service.get('v1/institution/getInstitutionTreeData')
        .then(res => {
          this.authForm.orgOptions = res
        }).finally(() => {
          this.authForm.orgLoading = false
        })
    },
    handleAuthFormSubmit () {
      this.$refs.authForm.validate((valid) => {
        if (valid) {
          this.handleAuthPost()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleAuthPost () {
      let group, org
      if (this.authForm.groupId) {
        group = this.getRow(this.authForm.groupOptions, 'value', this.authForm.groupId)
      }
      if (this.authForm.orgId.length) {
        org = this.findPathByLeafId(this.authForm.orgId[this.authForm.orgId.length - 1], this.authForm.orgOptions)
      }
      this.authFormDialog.loading = true
      service({
        method: 'post',
        url: '/v1/stamp/auth',
        data: {
          description: this.authForm.description,
          groupId: group && group.value,
          groupName: group && group.label,
          organizationId: org && org.id,
          organizationName: org && org.ins_name,
          stampId: this.authForm.stampId,
          type: this.authTable.type
        },
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
        transformRequest: [
          function (data) {
            return JSON.stringify(data)
          }
        ]
      }).then(res => {
        if (res.flag) {
          this.$swMessage({
            message: res.msg,
            type: 'success'
          })
          this.getAuthList()
          this.authFormDialog.visible = false
        }
      })
        .catch(error => {
          this.$swMessage.error(error)
        })
        .finally(() => {
          this.authFormDialog.loading = false
        })
    },
    handleAuthOperation (id, operation) {
      switch (operation) {
        case 'delete':
          this.handleAuthDelete(id)
          break
      }
    },
    handleAuthDelete (id) {
      this.$swConfirm('确认删除？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            id: id
          }
          return service.get('/v1/stamp/unAuth', { params })
        })
        .then(res => {
          this.$swMessage.success(res.msg)
          this.authTable.pageNum = 1
          this.getAuthList()
        })
        .catch(res => {
          this.$swMessage.error(res.msg)
        })
    },
    getRow (data, key, value) {
      let row
      data.forEach(v => {
        if (v[key] === value) {
          row = v
        }
      })
      return row
    },
    findPathByLeafId (leafId, nodes, path) {
      if (path === undefined) {
        path = {}
      }
      for (var i = 0; i < nodes.length; i++) {
        var tmpPath = path
        //   tmpPath.push(nodes[i].id);
        if (leafId === nodes[i].id) {
          tmpPath = nodes[i]
          return tmpPath
        }
        if (nodes[i].children) {
          var findResult = this.findPathByLeafId(leafId, nodes[i].children, tmpPath)
          if (findResult) {
            return findResult
          }
        }
      }
    },
    changePage (page) {
      this.stampTable.pageNum = page
      this.getStampList()
    },
    changeSize (size) {
      this.stampTable.pageSize = size
      this.getStampList()
    },
    changeAuthPage (page) {
      this.authTable.pageNum = page
      this.getAuthList()
    },
    changeAuthSize (size) {
      this.authTable.pageSize = size
      this.getAuthList()
    }
  }
}
</script>
<style lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 70px;
  line-height: 70px !important;
  text-align: center;
}
</style>
<style lang="scss" scoped>
.stamp {
  padding: 10px 20px;
  color: #445969;
  background-color: rgb(240, 245, 250);
  .h_date,
  .h_input {
    width: 140px;
  }
}
.authTableDialog_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.h_title {
  padding-left: 4px;
  border-left: 3px solid #3394e1;
  font-size: 12px;
}
.h_body {
  margin-top: 10px;
  padding: 10px 15px;
  box-shadow: 0px 2px 10px 0px rgba(39, 56, 70, 0.1);
  background: #fff;
  height: 80vh;
}
.hb_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hb_main {
  margin-top: 15px;
  padding-top: 15px;
  // border-top: 1px solid #ccc;
}
.h_select {
  width: 300px;
}

.hbm_left {
  width: 320px;
  padding-right: 15px;
}
.hbm_right {
  flex: 1;
  overflow-x: auto;
}
.hml_item_wrapper {
  max-height: 50vh;
  overflow-y: auto;
  width: 305px;
}
.hbml_item {
  margin-bottom: 10px;
}
.separator {
  font-size: 12px;
  width: 20px;
  text-align: center;
}
.needMore {
  padding: 0 20px;
  font-size: 13px;
  color: #ccc;
  cursor: pointer;
}
</style>
